import type { ICountryDefinition } from "@/countries/country-common";

import { EAddressProvider } from "@/domains/address/providers/address-provider.types.ts";
import { ECountry, ECountryCode, ELanguageCode } from "@/domains/country/country.types.ts";

export const SLOVENIA_DATABASE_COUNTRY_ID = 6;

export const SloveniaCountryDefinition = {
  addressProvider: EAddressProvider.GOOGLE,
  countryCode: ECountryCode.SLOVENIA,
  languageCode: ELanguageCode.SLOVENE,
  country: ECountry.SLOVENIA,
  phoneAllowed: true,
  addressAllowed: false,
  phone: {
    mask: "+386 9 999 99 9?9",
    placeholder: "+386 9 999 99 99",
    prefix: "+386",
  },
  databaseCountryId: SLOVENIA_DATABASE_COUNTRY_ID,
} as const satisfies ICountryDefinition;
